import { getNewRelic } from 'shared/analytics/new-relic';
import getEntriesLoadingStat from './entries-loading-stat';

const perf = global.vodPerformance || {
  now: _.noop,

  addVar: _.noop,
  addTimestamp: _.noop,

  stamps: {},
  vars: {},
};

const { addVar, addTimestamp, stamps, vars, now, isReady } = perf;

export const sendPerformanceInfo = _.once(() => {
  if (!isReady) {
    return;
  }

  try {
    getNewRelic().addPageAction('performance', {
      ...getEntriesLoadingStat(),
      ...vars,
    });
  } catch (err) {
    // new relic is no initiated
  }
});

export const addSingleMeasurement = (name, fromTimestamp = 'navigationStart') => {
  if (!stamps[name]) {
    addTimestamp(name, now());
  }

  if (!vars[name]) {
    addVar(name, now() - stamps[fromTimestamp]);
  }
};

export default perf;



// WEBPACK FOOTER //
// ./src/shared/utils/performance/index.js